export default __webpack_public_path__ + "static/media/closed.0cb15687.svg";